exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".favorite-link-item[data-v-7f8d6fc6]{padding:10px 0;cursor:move}.no-links[data-v-7f8d6fc6]{padding:80px 0;text-align:center}.delete-button-area[data-v-7f8d6fc6]{text-align:right;padding-top:30px}.arrow-area[data-v-7f8d6fc6]{padding:30px 10px}.arrow-area[data-v-7f8d6fc6],.controls[data-v-7f8d6fc6]{text-align:right}", ""]);

